import { Box, Button, styled } from '@mui/material'

export const DeleteImageText = styled(Box)(() => ({
  fontSize: '24px',
  color: '#000',
  fontWeight: '700',
  textAlign: 'center',
  marginBottom: '8px',
}))

export const DeleteImageDescription = styled(Box)(() => ({
  fontSize: '16px',
  color: '#000',
  fontWeight: '400',
  textAlign: 'center',
}))

export const CancelButton = styled(Button)(() => ({
  backgroundColor: '#F7F7F7',
  width: '125px',
  height: '40px',
  border: '1px solid #D4D4D4',
  borderRadius: '4px',
  color: '#000',
  textTransform: 'none',
}))

export const DeleteButton = styled(Button)(() => ({
  border: '1px solid #F23D3D',
  borderRadius: '4px',
  color: '#F23D3D',
}))
